
import {Component, Prop, Vue} from "vue-property-decorator";
import dataFieldTypesReadonly from "@/dataFieldReadonlyTypes";
import ReadonlyDataField from "@/models/ReadonlyDataField";

@Component({
  name: 'ListFieldReadonly',
  components: {
    ...dataFieldTypesReadonly,
  },
})
export default class ListFieldReadonly extends Vue {

  @Prop({required: true})
  private dataField: ReadonlyDataField

  get isVisible() {
    return this.dataField.isVisible ?? false;
  }

  get displayName() {
    return this.dataField?.displayName;
  }

  get childFields() {
    console.log("List childs:", this.dataField.childFields.length)
    return this.dataField?.childFields ?? [];
  }

}
